module.exports = __webpack_public_path__ + "static/media/level1-3c.fb091f57.mp3";